/* eslint-disable jsx-a11y/media-has-caption */
import { useVirtualMCSettings } from '@/src/hooks/store/useVirtualMCSettings';
import { useEffect, useRef } from 'react';
import styles from './VideoModal.module.scss';
import { Icon } from '@amzn/awsui-components-react';

interface VideoModalProps {
  onClose?: () => void;
}

export const VideoModal = ({ onClose }: VideoModalProps) => {
  const dataStore = useVirtualMCSettings();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const closeDialogHandler = useRef(() => {
    dataStore.setVideoVisible(false);
    dataStore.setPlayingVideoSrc(null);
    onCloseRef.current?.();
  });
  const openDialogAfterVideoLoadHandler = useRef(() => {
    dialogRef.current?.showModal();
  });
  const clearSourceAfterDialogCloseHandler = useRef(() => {
    dataStore.setPlayingVideoSrc(null);
  });

  const onErrorLoadingVideoHandler = useRef((err: ErrorEvent) => {
    // eslint-disable-next-line no-console
    console.error('video loading error', err);
    dataStore.setVideoVisible(false);
    dataStore.setPlayingVideoSrc(null);
  });
  const dialogRef = useRef<HTMLDialogElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const sourceRef = useRef<HTMLSourceElement>(null);

  useEffect(() => {
    if (dataStore.videoVisible) {
      videoRef.current?.addEventListener('ended', closeDialogHandler.current, false);
      videoRef.current?.addEventListener('canplay', openDialogAfterVideoLoadHandler.current, false);
      dialogRef.current?.addEventListener('cancel', closeDialogHandler.current, false);
      dialogRef.current?.addEventListener('close', clearSourceAfterDialogCloseHandler.current, false);
      sourceRef.current?.addEventListener('error', onErrorLoadingVideoHandler.current, false);
    } else {
      if (dialogRef.current?.open) {
        dialogRef.current?.close();
      }
    }
    return () => {
      dialogRef.current?.removeEventListener('cancel', closeDialogHandler.current);
      dialogRef.current?.removeEventListener('close', clearSourceAfterDialogCloseHandler.current);
      videoRef.current?.removeEventListener('ended', closeDialogHandler.current);
      videoRef.current?.removeEventListener('canplay', openDialogAfterVideoLoadHandler.current);
      sourceRef.current?.removeEventListener('error', onErrorLoadingVideoHandler.current, false);
    };
  }, [dataStore.videoVisible]);

  return (
    <dialog id="video-dialog" ref={dialogRef} className={styles.main}>
      <div>
        <button
          onClick={(ev) => {
            ev.preventDefault();
            dialogRef.current?.close();
            closeDialogHandler.current();
          }}
        >
          <Icon name="close" size="small" />
        </button>
      </div>
      {!!dataStore.playingVideoSrc && (
        <video ref={videoRef} id="video-player" autoPlay>
          <source ref={sourceRef} src={dataStore.playingVideoSrc} type="video/mp4" />
        </video>
      )}
    </dialog>
  );
};
